module.exports = __webpack_public_path__ + "static/media/logo_wb.c019ea90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_wb.png
// module id = 517
// module chunks = 0